export const TEST_LOG_OUT_TIMER_DURATION = 1 * 60 * 1000
// 5 minutes / 300 seconds / 300000 milliseconds
export const LOG_OUT_TIMER_DURATION = 5 * 60 * 1000

export const TEST_INACTIVITY_DURATION = 1 * 60 * 1000
// 2 hours / 120 minutes / 7200 seconds / 7200000 milliseconds
export const INACTIVITY_DURATION = 2 * 60 * 60 * 1000

export const TEST_THROTTLE_DURATION = 250
// 1 minutes / 60 seconds / 60000 milliseconds
export const THROTTLE_DURATION = 1 * 60 * 1000

// 1 minutes / 60 seconds / 60000 milliseconds
export const SYNC_TAB_TIMERS_DURATION = 1 * 60 * 1000

// Inactivity timer name
export const TAB_INACTIVITY_TIMER_NAME = "TAB_INACTIVITY_TIMER_NAME"

// Session storage key for log out message
export const INACTIVITY_LOG_OUT_SNACKBAR = "INACTIVITY_LOG_OUT_SNACKBAR"

export const INACTIVITY_LOG_OUT_MESSAGE =
  "You were logged out due to inactivity."
